import styled from 'styled-components';
import { SmallPortalTooltip } from '../../Tooltip';
import { PSmall } from '../../elements/Text';
import { TooltipContent, TooltipDetail, TooltipTitle } from './Tooltip';
import { CellContext } from '@tanstack/react-table';
import { LearnerProgress } from '.';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

const NameText = styled(PSmall)<{ isBold?: boolean }>`
  font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
  padding: 0;
`;

const NameContainer = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default function MentorOfficeHourCell(
  info: CellContext<LearnerProgress, unknown>
) {
  const officeHours = info.row.original.officeHours;
  const mentor = info.row.original.mentor;
  if (!officeHours || !mentor) {
    return '-';
  }

  const tooltipId = `mentor-office-hour-${info.row.id}`;
  const officeHour =
    officeHours.officeHours.length > 0
      ? `${dayjs
          .utc(officeHours.officeHours[0].timestamp)
          .local()
          .format('dddd[s] ha')} GMT${dayjs
          .utc(officeHours.officeHours[0].timestamp)
          .local()
          .format('Z')}`
      : '-';

  return (
    <NameContainer className={tooltipId}>
      <NameText>{mentor.name ?? 'N/A'}</NameText>
      <SmallPortalTooltip anchorSelect={`.${tooltipId}`}>
        <TooltipContent>
          <TooltipTitle>Email</TooltipTitle>
          <TooltipDetail>{mentor.email}</TooltipDetail>
          <TooltipTitle style={{ marginTop: '16px' }}>
            Office Hours
          </TooltipTitle>
          <TooltipDetail>{officeHour}</TooltipDetail>
        </TooltipContent>
      </SmallPortalTooltip>
    </NameContainer>
  );
}
